import Modal from 'components/welcomeModal';
import ContentMaintenance from './ContentMaintenance';

import './MaintenanceModal.scss';

type Props = {
  message?: string;
};

const MaintenanceModal = ({ message }: Props) => {
  return (
    <Modal hideCloseBtn={true}> {/* No need to close */}
      <ContentMaintenance message={message} />  
    </Modal>
  );
};

export default MaintenanceModal;
